import {withJsonFormsLayoutProps} from '@jsonforms/react';
import PropTypes from 'prop-types';
import CustomLayoutRenderer from '../CustomLayoutRenderer';

const HorizontalLayout = ({
  schema,
  uischema,
  path,
  renderers,
  cells,
  enabled,
  visible,
  label
}) => {
  const layoutProps = {
    elements: uischema.elements,
    schema: schema,
    path: path,
    direction: 'row',
    gap: uischema.gap,
    visible: visible,
    uischema: uischema,
    renderers: renderers,
    label: label,
    cells: cells,
    enabled: enabled
  };
  return <CustomLayoutRenderer {...layoutProps} />;
};

HorizontalLayout.propTypes = {
  schema: PropTypes.object.isRequired,
  uischema: PropTypes.shape({
    elements: PropTypes.array.isRequired,
    gap: PropTypes.string
  }).isRequired,
  path: PropTypes.string,
  renderers: PropTypes.array.isRequired,
  cells: PropTypes.array.isRequired,
  enabled: PropTypes.bool.isRequired,
  visible: PropTypes.bool.isRequired,
  label: PropTypes.string
};

const HorizontalLayoutControl = withJsonFormsLayoutProps(HorizontalLayout);
HorizontalLayoutControl.displayName = 'HorizontalLayoutControl';

export {HorizontalLayoutControl};
export default HorizontalLayoutControl;
